/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React, {useState, useEffect} from "react";
import parseHtmlContent from "helpers/parseHtmlContent";

import styled from "styled-components";

import Slider from "react-slick";

import {successStories} from "nxtconstants";

import {WealthyEnv} from "helpers";

const starImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-success-stories-star.svg`;

const SuccessStories = () => {
  const [settings, setSettings] = useState({
    infinite: true,
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    swipeToSlide: true,
    variableWidth: true
  });

  useEffect(() => {
    const windowWidth = window.innerWidth;

    const newSettings = {...settings};

    if (windowWidth < 1124) {
      newSettings.slidesToScroll = 2;
      newSettings.slidesToShow = 2;
      setSettings(newSettings);
    }
    if (windowWidth < 768) {
      newSettings.slidesToScroll = 1;
      newSettings.slidesToShow = 1;
      newSettings.variableWidth = false;
      setSettings(newSettings);
    }
  }, []);

  useEffect(() => {
    const windowWidth = window.innerWidth;
    const elements = document.getElementsByClassName("each-success-card-partners partners-landing-page");
    for (let i = 0; i < elements.length; i++) {
      elements[i].parentNode.style.marginLeft = "3rem";
      if (windowWidth < 768) {
        elements[i].parentNode.style.marginLeft = "";
      }
    }
  }, []);

  return (
    <>
      <SuccessStoriesWrapper id="success-stories">
        <Title>Success stories of people just like you</Title>
        <SuccessStoryContainer>
          <Slider
            {...settings}
          >
            {
              successStories.map((story, index) => {
                return (
                  <Card className="partners-landing-page each-success-card-partners" key={index}>
                    <HeaderContainer>
                      <AvatarNameContainer>
                        <Avatar alt="wealthy-partner-avatar-image" loading="lazy" src={story.avatar} />
                        <NameDateContainer>
                          <Name>Wealthy Partner</Name>
                          <Date>{story.date}</Date>
                        </NameDateContainer>
                      </AvatarNameContainer>
                      <StarImage alt="star-image" loading="lazy" src={starImage} />
                    </HeaderContainer>
                    <Description>
                      {story.description}
                    </Description>
                    <FooterDescription>
                      <ManagerName>{story.managerName}</ManagerName>
                      <Content><span className="main-profile">{parseHtmlContent(story.mainExperience)}</span> {story.pastExperience}</Content>
                    </FooterDescription>
                  </Card>
                );
              })
            }
          </Slider>
        </SuccessStoryContainer>
      </SuccessStoriesWrapper>
    </>
  );
};

const SuccessStoriesWrapper = styled.div`
  padding: 5rem 0;
  overflow: hidden;
  padding-left: 5%;

  @media (max-width: 768px) {
    width: 95%;
    margin: 0 auto;
    padding-left: 0;
  }
`;

const Title = styled.h3`
  font-family: MavenPro;
  font-size: 3.6rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000;

  @media (max-width: 768px) {
    font-size: 2.4rem;
    width: 90%;
    margin: 0 auto;
    font-weight: bold;
  }

`;

const SuccessStoryContainer = styled.div`
  display: block;
  width: 100%;
  margin: 8rem auto;
  .slick-dots {
    bottom: -50px !important;
  }

  @media (max-width: 768px) {
    width: 95%;
    margin: 5rem  auto;
  }
`;


const Card = styled.div`
  padding: 4rem;
  border-radius: 2.4rem;
  background-color: #f9f9f9;
  display: block;
  width: unset !important;
  height: 50rem;

  @media (max-width: 768px) {
    padding: 3rem;
    height: 44rem;
  }
`;

const Name = styled.p`
  font-family: MavenPro;
  font-size: 2.4rem;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1c1c1c;

  @media (max-width: 768px) {
    font-size: 2.4rem;
  }
`;

const FooterDescription = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5rem;
`;

const ManagerName = styled(Name)`
  font-weight: 600;
`;

const Content = styled(Name)`
  margin-top: 1rem;
  font-weight: 500;
  font-size: 1.8rem;
  .main-profile {
    font-weight: 600;
  }

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const Description = styled.div`
  margin-top: 5rem;
  font-family: MavenPro;
  font-size: 2.4rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: left;
  color: #7e7e7e;
  max-width: 42rem;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }

`;

const AvatarNameContainer = styled.div`
  display: flex;
  margin-right: 13rem;

  @media (max-width: 768px) {
    margin-right: 0;
  }
`;

const NameDateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  margin-left: 2rem;
`;

const Date = styled.p`
  font-family: MavenPro;
  font-size: 1.8rem;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #7e7e7e;
  margin-top: 1rem;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    margin-top: 0.5rem;
  }
`;

const StarImage = styled.img`
  @media (max-width: 768px) {
    display: none !important;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
`;

const Avatar = styled.img`
  width: 7.2rem;
`;


export default SuccessStories;
